<div [class]="containerClasses()" [ngStyle]="editorStyles()">
    @if (label()) {
        <label [for]="inputId">
            {{ label() | translate }}
            @if (isRequired()) {
                <span class="text-danger" aria-label="required">*</span>
            }
        </label>
    }

    <div [class]="editorClasses()" [ngStyle]="editorStyles()">
        <!-- Menu do Editor -->
        <ngx-editor-menu
                [editor]="editor"
                [toolbar]="toolbar()"
                [colorPresets]="['red', 'blue', 'green', 'yellow', 'orange', 'purple']">
        </ngx-editor-menu>

        <!-- Editor de Conteúdo -->
        <ngx-editor
                [editor]="editor"
                [ngModel]="currentValue"
                [disabled]="isDisabled()"
                [placeholder]="placeholder() | translate"
                [id]="inputId"
                [attr.aria-describedby]="getAriaDescribedBy()"
                [attr.aria-invalid]="hasErrors"
                [attr.aria-required]="isRequired()"
                (ngModelChange)="onEditorContentChange($event)"
                (focus)="onEditorFocus()"
                (blur)="onEditorBlur()">
        </ngx-editor>
    </div>

    <!-- Contador de caracteres -->
    @if (showCharacterCount()) {
        <div
                class="form-text d-flex justify-content-end"
                [id]="inputId + '_count'"
                [class.text-danger]="isOverLimit()">
            <small>{{ characterCountText() }}</small>
        </div>
    }

    <!-- Texto de ajuda -->
    @if (hint()) {
        <div class="form-text" [id]="inputId + '_hint'">
            {{ hint() | translate }}
        </div>
    }

    <!-- Mensagens de erro -->
    @if (showErrorDescription()) {
        @if (ngControl?.control) {
            <app-control-error
                    [control]="getControl()"
                    [customErrors]="customErrors()"
                    [id]="inputId + '_error'">
            </app-control-error>
        }
    }
</div>
